import React, { useEffect, useMemo, useState } from 'react'
import { Container } from 'react-bootstrap'
import { Footer, KonektoNavbar, Loader } from '../../components'
import './User.scss'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { authService } from '../../services/authService'
import moment from 'moment/moment'
import placeholderImage from '../../assets/images/detailsPlaceholder.jpg'
import { IoChevronForwardSharp } from 'react-icons/io5'
import { GoVerified } from 'react-icons/go'
import { LuClock, LuMessageSquareText } from 'react-icons/lu'

export default function User() {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { token } = useSelector(state => state.authentication)

  const { userId } = useParams()

  const [user, setUser] = useState()
  const [loader, setLoader] = useState()

  const company = useMemo(() => {
    if (user?.company?.id) {
      return user.company
    } else return null
  }, [user])

  const companyImage = useMemo(() => {
    let image = placeholderImage

    if (company?.cover_image) {
      image = company?.cover_image
    }

    return image
  }, [company])

  const companyStatus = useMemo(() => {
    if (!company) {
      return null
    }

    const isVerified = company?.is_verified

    if (isVerified === null || isVerified === 0) {
      return (
        <div className="d-flex align-items-center">
          <LuClock className="fs-5" color="orange" />
          <span>Firma nije verifikovana</span>
        </div>
      )
    } else if (isVerified === 1) {
      return (
        <div className="d-flex align-items-center">
          <GoVerified className="fs-5" color="green" />
          <span>Firma je verifikovana</span>
        </div>
      )
    } else {
      return null
    }
  }, [company])

  const registrationDate = useMemo(() => {
    let date = ''

    if (user) {
      const date = moment(user.created_at).format('DD.MM.YYYY.')
      return `Datum registracije: ${date}`
    }

    return date
  }, [user])

  useEffect(() => {
    const getUserInfo = async () => {
      setLoader(true)

      const response = await authService.getUserInfo({ userId })
      if (response.isOk) {
        setUser(response.data)
      }

      setLoader(false)
    }

    getUserInfo()
  }, [userId])

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'instant' })
    }, 200)
  }, [])

  return (
    <div id="user">
      <KonektoNavbar />
      <Container className="mt-5 w-50">
        {loader ? (
          <Loader />
        ) : (
          <>
            <div className="form-group-wrapper">
              <div className="user-info">
                <h4 className="fw-medium">{`${user?.first_name} ${user?.last_name}`}</h4>
                <span>{registrationDate}</span>
                {token ? <LuMessageSquareText /> : null}
              </div>
            </div>

            <div className="form-group-wrapper company">
              <h4>{`Firma`}</h4>

              <hr className="hr divider" />

              {company ? (
                <div
                  onClick={() => navigate(`/firma/${company.id}`)}
                  className="d-flex align-items-center pointer">
                  <div className="d-flex w-100">
                    <img src={companyImage} />

                    <div className="ms-2 mt-1">
                      <h5 className="ms-1 mb-1">{company?.name}</h5>
                      {companyStatus}
                    </div>
                  </div>

                  <IoChevronForwardSharp />
                </div>
              ) : (
                <p className="warning-text text-center mt-4">{`Korisnik nije dodao firmu`}</p>
              )}
            </div>
          </>
        )}
      </Container>
      <Footer />
    </div>
  )
}
